(function () {
  function initTriptych(section) {
    if (!section || section.dataset.bnzTriptychInit) return;
    section.dataset.bnzTriptychInit = '1';

    var lightbox = section.querySelector('[data-bnz-triptych-lightbox]');
    var content = section.querySelector('[data-bnz-triptych-lightbox-content]');
    var closeBtn = section.querySelector('.bnz-triptych-lightbox__close');
    if (!lightbox || !content) return;

    function open(src, alt) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = alt || '';
      content.innerHTML = '';
      content.appendChild(img);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () {
        content.innerHTML = '';
      }, 300);
    }

    section.querySelectorAll('[data-bnz-triptych-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-lightbox-src');
        if (!src) return;
        open(src, btn.getAttribute('data-lightbox-alt'));
      });
    });

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === closeBtn) close();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);

    lightbox._bnzTriptychClose = close;
  }

  if (!window.__bnzTriptychEscapeBound) {
    window.__bnzTriptychEscapeBound = true;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-bnz-triptych-lightbox].is-open').forEach(function (lb) {
        if (typeof lb._bnzTriptychClose === 'function') lb._bnzTriptychClose();
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-bnz-triptych]').forEach(initTriptych);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-bnz-triptych]') || e.target.closest('[data-bnz-triptych]');
    if (section) initTriptych(section);
  });
})();
